import { postAny } from "../Api";

export interface AddonForm {
  addonId: string;
  quantity?: number;
}

export async function addAddon(quoteId: string, addon: AddonForm) {
  return postAny<AddonForm>(`store/quote/add-addon/${quoteId}`, addon);
}

export async function changeQuantityAddon(quoteId: string, addon: AddonForm) {
  return postAny<AddonForm>(`store/quote/change-quantity-addon/${quoteId}`, addon);
}

export async function removeAddon(quoteId: string, addon: AddonForm) {
  return postAny<AddonForm>(`store/quote/remove-addon/${quoteId}`, addon);
}